import type { JSX } from 'react';
import { guideNumber } from '../shell/look';
import { stepNumber } from './catalog';

/** "01 · …, 02 · …": a numbered setup guide, as the design lays it out. */
export function GuideList({ steps }: { steps: readonly string[] }): JSX.Element {
  return (
    <ol className="m-0 flex list-none flex-col gap-2.5 p-0">
      {steps.map((text, i) => (
        <li
          key={text}
          className="grid grid-cols-[22px_minmax(0,1fr)] gap-3 text-[13.5px] leading-[1.55]"
        >
          <span className={guideNumber}>{stepNumber(i)}</span>
          <span>{text}</span>
        </li>
      ))}
    </ol>
  );
}
